import React from "react";
import { NavLink } from "react-router-dom";
import { Home, BookOpen, Compass, BarChart3, User } from "lucide-react";
import { useLang } from "@/context/LangContext";

const items = [
  { to: "/home", icon: Home, key: "nav_home", id: "home" },
  { to: "/learn", icon: BookOpen, key: "nav_learn", id: "learn" },
  { to: "/life", icon: Compass, key: "nav_life", id: "life" },
  { to: "/progress", icon: BarChart3, key: "nav_progress", id: "progress" },
  { to: "/profile", icon: User, key: "nav_profile", id: "profile" },
];

export default function BottomNav() {
  const { t } = useLang();
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[460px] z-50 bg-white/95 backdrop-blur-xl border-t border-slate-200/70 px-2 pt-2 flex justify-around items-center"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 8px)", boxShadow: "0 -8px 30px -18px rgba(15,23,42,0.25)" }}
      data-testid="bottom-nav"
    >
      {items.map(({ to, icon: Icon, key, id }) => (
        <NavLink key={id} to={to} data-testid={`bottom-nav-${id}`} className="flex flex-col items-center gap-1 px-2 py-1 min-w-[58px]">
          {({ isActive }) => (
            <>
              <span className={`flex items-center justify-center w-11 h-9 rounded-2xl transition-all duration-300 ${isActive ? "bg-[#2563EB]/10 text-[#2563EB] scale-105" : "text-slate-400"}`}>
                <Icon size={20} strokeWidth={2.2} />
              </span>
              <span className={`text-[10px] font-semibold transition-colors ${isActive ? "text-[#2563EB]" : "text-slate-400"}`}>{t(key)}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
